import Dropdown from 'react-bootstrap/Dropdown'
import DropdownMenu from 'react-bootstrap/DropdownMenu'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { restoreDefaultProps, restoreFindDOMNode } from '.'

// Dropdown.Item renders `as` (from defaultProps).
restoreDefaultProps(Dropdown, DropdownMenu, DropdownItem)
restoreFindDOMNode()
